import PropTypes from 'prop-types';
import React from 'react';
import JsonUtil from '../../cornucopia/core/json-util';
import getStructuredDataAttributes from '../lib/StructuredDataAttributes';

class JsonLdOrganization extends React.Component {
  static propTypes = {
    description: PropTypes.string,
  };

  static defaultProps = {
    description: '',
  };

  _generateJsonString = () => {
    const properties = getStructuredDataAttributes();

    const jsonSchemaObject = {
      '@context': 'http://schema.org/',
      '@type': 'RealEstateAgent',
      name: properties.name,
      description: this.props.description,
      url: properties.url,
      logo: properties.logo,
      image: properties.image,
      email: properties.email,
      telephone: properties.telephone,
      address: properties.address,
      priceRange: properties.priceRange,
      sameAs: properties.sameAs,
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: properties.ratingValue,
        reviewCount: properties.ratingCount,
        bestRating: properties.bestRating,
        worstRating: properties.worstRating,
      }
    };

    return JsonUtil.objectToReactJsonString(jsonSchemaObject);
  };

  render() {
    return (
      <script type="application/ld+json" dangerouslySetInnerHTML={this._generateJsonString()} />
    );
  }
}

export default JsonLdOrganization;